import * as utils from './utils';
import Newsletter from './components/Newsletter.vue';
import * as VueGoogleMaps from './vendor/vue-google-maps/main';
var win = window;
var $ = win.jQuery;
$(function () {
    win.objectFitImages('.fill-image');
    // Utility classes for the parts of the site that don't
    // really need the whole bloat of Vue.js directives
    utils.scrollToLinks('.scroll-to, [data-scroll-to]', parseInt($('.content').css('margin-top')));
    utils.toggleLinks();
    utils.inFieldLabels();
    utils.focusLinks();
    utils.toggleAriaExpanded();
    utils.screenReaderNotifications();
    utils.slideshowA11y();
    utils.fixVH();
    utils.mainMenu();
    utils.initGoogleMaps();
    utils.initVues({
        'google-map': VueGoogleMaps.Map,
        'google-map-marker': VueGoogleMaps.Marker,
        'newsletter': Newsletter,
    });
    slideshows();
    carousels();
    galleryPopup();
    topBanner();
    setTimeout(function () {
        $('body').addClass('is-loaded');
    }, 150);
});
/**
 * Gallery popup
 */
function galleryPopup() {
    var reactToHash = function () {
        var hash = window.location.hash;
        var hasImageHash = hash.indexOf('#image/') != -1;
        if (hasImageHash) {
            var imageIndex = parseInt(hash.replace('#image/', ''), 10);
            $('.slideshow').cycle('goto', imageIndex);
        }
        setTimeout(function () { return $('html').toggleClass('is-gallery-open', hasImageHash); }, 200);
    };
    var closeOnEscape = function () {
        $(window).on('keyup', function (e) {
            if (e.key == 'Escape') {
                window.location.hash = '';
            }
        });
    };
    reactToHash();
    closeOnEscape();
    $(window).on('hashchange load', function () { return reactToHash(); });
}
/**
 * Top banner
 */
function topBanner() {
    var $body = $('body');
    $('.top-banner__close').on('click', function () {
        $body.removeClass('is-with-top-banner');
        $.cookie('top-banner-shown', true, { path: '/', expires: 7 });
    });
    if (!$.cookie('top-banner-shown') && !!$('.top-banner').length) {
        $body.addClass('is-with-top-banner');
    }
}
/**
 * Flickity carousels
 */
function carousels() {
    $('.carousel').each(function (i, item) {
        var $flickity = $(item).flickity({
            cellSelector: '.carousel__cell',
            cellAlign: 'center',
            contain: true,
            imagesLoaded: true,
            wrapAround: true,
            prevNextButtons: true,
            resize: true,
            pageDots: false,
            friction: 0.35,
        });
        $(window).on('load resize', function () { return $flickity.flickity('resize'); });
    });
}
/**
 * Cycle2 slideshows
 */
function slideshows() {
    $('.slideshow').each(function (i, item) {
        if ($(item).is('.cycle-slideshow')) {
            $(item).cycle('destroy');
        }
        else {
            var timeout = $(item).is('[data-timeout]') ? $(item).data('timeout') : 5000;
            var speed = $(item).is('[data-speed]') ? $(item).data('speed') : 600;
            var options = {
                'slides': '> .slideshow__slide',
                'pager': '> .slideshow__pager, ~ .slideshow__pager',
                'next': '> .slideshow__next',
                'prev': '> .slideshow__prev',
                //'swipe': 'true',
                //'swipeFx': 'fade',
                'pagerTemplate': "<a role='button' \n                            data-index='{{slideNum}}' \n                            href='javascript:void(0)' title=\"{{slideNum}}\" class='pager__item'>                \n                          </a>",
                'timeout': timeout,
                'speed': speed,
                'fx': 'fade',
            };
            $(item)
                .on('cycle-initialized', function () {
                $(item).addClass('is-loaded');
            })
                .on('cycle-before', function (event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag) {
                var isBlack = !!$(incomingSlideEl).find('.is-black').length;
                $(item).toggleClass('is-slideshow-black', isBlack);
            })
                .cycle(options);
            $(window).on('keyup', function (e) {
                if (e.key === 'ArrowLeft')
                    $(item).cycle('prev');
                else if (e.key == 'ArrowRight')
                    $(item).cycle('next');
            });
        }
    });
}
